module.exports = __webpack_public_path__ + "img/asset_GMT.c730a8da.svg";